/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Forge Design Automation team for Inventor
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Surface from '@hig/surface';
import './app.css';
import Toolbar from './components/toolbar';
import TabsContainer from './components/tabsContainer';
import ProjectSwitcher from './components/projectSwitcher';
import { showAdoptWithParamsFailed, fetchShowParametersChanged } from './actions/uiFlagsActions';
import { detectToken } from './actions/profileActions';
import ModalProgress from './components/modalProgress';
import ModalFail from './components/modalFail';
import ModalContact from './components/modalContact';
import { adoptWithParamsFailed, embeddedModeEnabled, embeddedModeUrl, adoptWithParamsProgressShowing, modalContactShowing, errorData } from './reducers/mainReducer';
import { adoptProjectWithParameters } from './actions/adoptWithParamsActions';
import { adoptProjectWithParametersJSON } from './actions/adoptWithParamsJSONActions';

export class App extends Component {
  constructor(props) {
    super(props);
    props.detectToken();
  }

    componentDidMount() {
        const bEmbedded = (this.props.match && this.props.match.params.embeddedProjectId != null);

        if (bEmbedded)
        {
            this.props.fetchShowParametersChanged();

            this.props.adoptProjectWithParametersJSON(this.props.match.params.embeddedProjectId);
        }
        else
        {
            if (!this.props.embeddedModeEnabled)
            {
                this.props.fetchShowParametersChanged();
            }

            if (this.props.embeddedModeUrl != null)
            {
                this.props.adoptProjectWithParameters(this.props.embeddedModeUrl);
            }
        }
    }

    render() {
      const showToolbar = !this.props.embeddedModeEnabled;
      const embeddedModeEnabled = this.props.embeddedModeEnabled;

      return (
        <Surface className="fullheight" id="main" level={200}>
        { showToolbar &&
            <Toolbar>
                <ProjectSwitcher />
            </Toolbar>
              }

            <TabsContainer />

        { !embeddedModeEnabled &&
            <img className="logo-mum" src={"logo-mum.png"} alt="" />
              }

        {this.props.adoptWithParamsProgressShowing &&
            <ModalProgress
                open={true}
                title="Loading Content"
                label=" "
                icon="/Assembly_icon.svg"/>
              }
        {this.props.adoptWithParamsFailed &&
            <ModalFail
                open={true}
                title="Loading Failed"
                contentName="Project:"
                label=" "
                isPermanent={true}
                onClose={() => { }}
                errorData={this.props.errorData} />
              }

        <ModalContact
            open={this.props.modalContactShowing}
            title="Richiesta Preventivo"
            contentName="contentName"
            label="label"
        />

        </Surface>
    );
  }
}

/* istanbul ignore next */
export default connect(function (store) {
  return {
    adoptWithParamsProgressShowing: adoptWithParamsProgressShowing(store),
    adoptWithParamsFailed: adoptWithParamsFailed(store),
    embeddedModeEnabled: embeddedModeEnabled(store),
    embeddedModeUrl: embeddedModeUrl(store),
    errorData: errorData(store),
    modalContactShowing: modalContactShowing(store)
  };}, {
    showAdoptWithParamsFailed, adoptProjectWithParameters, adoptProjectWithParametersJSON, fetchShowParametersChanged, detectToken
})(App);

